module.exports = __webpack_public_path__ + "img/furnitureshop-specification.4a705685.png";